export const ID6 = () => {
    return (
        <div>
            <h2 className="servicePage_title">БЮДЖЕТИРОВАНИЕ</h2>
            <div className="content" readonly="">;
                <div className="section__tab" id="01">
                    <div className="about-card__title">Характеристика конфигурации</div>
                    <p>
                        <b>
                            Прикладное решение «1С-Рейтинг: Бюджетирование предприятия» предназначено для автоматизации
                            процессов бюджетирования предприятий, осуществляющих
                            любые виды коммерческой деятельности. Позволяет автоматизировать все шаги бюджетного
                            процесса – от создания структуры бюджетов и ввода плановых
                            данных до автоматизированного сбора фактических данных в режиме on-line и получения
                            отчетности по план-фактному анализу бюджетов, также другой
                            аналитической отчетности.
                        </b>
                    </p>

                    <p>
                        «1С-Рейтинг: Бюджетирование предприятия» представляет собой дополнение к любой конфигурации на
                        платформе 1С:Предприятие 8, соответствующей минимальному
                        перечню требований. Таким образом, продукт может быть использован в любом регионе или стране.
                        Кроме этого решение может функционировать как
                        самостоятельное.
                    </p>

                    <p>
                        Программный продукт будет наиболее эффективен на предприятиях, заинтересованных в оперативном
                        управлении финансовыми потоками и финансовом планировании.
                        Используя прикладное решение «1С-Рейтинг: Бюджетирование предприятия», предприятие получает
                        инструменты планирования финансового состояния, составления
                        мастер-бюджетов (бюджет доходов и расходов, бюджет движения денежных средств, прогнозный баланс)
                        и других оборотных бюджетов, анализа отклонений
                        плановых и фактических данных.
                    </p>

                    <p>С помощью прикладного решения «1С-Рейтинг: Бюджетирование предприятия» предприятие может
                        автоматизировать следующие процессы:</p>

                    <ul>
                        <li>финансовое планирование (бюджетирование и отражение фактических данных в бюджетах);</li>

                        <li>групповое согласование и утверждение документов.</li>
                    </ul>

                    <p>
                        <b>Прикладное решение включает следующие подсистемы:</b>
                    </p>

                    <p>
                        <b>Подсистема «Бюджетирование»</b> реализует функции, необходимые для построения системы
                        финансового управления на предприятии:
                    </p>

                    <ul>
                        <li>постановка системы бюджетирования в целом для предприятия или холдинга;</li>

                        <li>настройка структуры бюджетов согласно потребностям предприятия. Возможность версионирования
                            состава статей бюджета;
                        </li>

                        <li>
                            возможность сценарного планирования бюджетов - параллельного планирования бюджетов с
                            различными вариантами развития событий, различной структурой
                            бюджетного периода и горизонтом планирования, также возможность сценарного планирования с
                            применением моделирования курса валют;
                        </li>

                        <li>
                            пакетное создание бюджетов путем копирования бюджетов других периодов или сценариев с
                            применением поправочных коэффициентов на все, либо выбранные
                            статьи формируемого бюджета;
                        </li>

                        <li>формирование бюджетного регламента, гибкая настройка схем автоматического получения сводных
                            и консолидированных бюджетов различными способами;
                        </li>

                        <li>календарное планирование исполнения и контроля исполнения задач пользователей в рамках
                            процесса бюджетирования;
                        </li>

                        <li>
                            упрощение работы пользователя по вводу плановых показателей - настройка различного рода
                            зависимостей между статьями бюджета или различных бюджетов и
                            настройка моделей расчета для отдельных статей (как на основании других плановых данных, так
                            и на основании данных регламентированного учета –
                            например, остатков товаров или денежных средств и т.д.), автоматическое выполнение расчетов
                            на основании установленных зависимостей и моделей;
                        </li>

                        <li>раздельное формирование бюджетов подразделений и проектов, с возможностью автоматического
                            объединения в сводные и консолидированные бюджеты;
                        </li>

                        <li>
                            планирование бюджетов предприятия в натуральных и суммовых показателях, с применением
                            различной детализации по измерениям бюджетирования
                            (дополнительной аналитики) – центрам ответственности, проектам, контрагентам и
                            номенклатурным позициям. Предусмотрена возможность определить до
                            десяти дополнительных разрезов, ссылающихся на выбранную пользователем справочную
                            информацию;
                        </li>

                        <li>поддержка схем планирования бюджетов «сверху-вниз» и «снизу-вверх»;</li>

                        <li>подача заявок от подразделений на формирование бюджетов и автоматизированное формирование
                            бюджетов на основании поданных заявок;
                        </li>

                        <li>корректировка бюджетов, поддержка версионности корректируемых бюджетов. Учет и анализ причин
                            корректировок;
                        </li>

                        <li>настраиваемые формы печати и отчетности по бюджетам (в т.ч. на нескольких языках),
                            исключение внутригрупповых оборотов из отчетов;
                        </li>

                        <li>
                            установка лимитов (контрольных границ) – целевых (для анализа превышений в отчетности) и
                            ограничивающих (для недопущения формирования плановых или
                            фактических операций сверх лимита). В качестве лимитов могут использоваться сформированные
                            бюджеты определенного сценария планирования;
                        </li>

                        <li>
                            возможность планирования остаточных показателей (в том числе и для преемственности бюджетов
                            следующих периодов) и ведения управленческого учета на
                            предприятии на основании управленческого плана счетов, структура которого может определяться
                            пользователем для собственных нужд;
                        </li>

                        <li>мониторинг фактической деятельности предприятия в тех же разрезах, в которых проводилось
                            планирование;
                        </li>

                        <li>
                            полностью настраиваемые схемы отражения фактических данных в бюджетах предприятия и на
                            счетах управленческого плана счетов предоставляют предприятию
                            возможность постановки финансового (управленческого) учета и контроля фактических данных в
                            соответствии с собственными потребностями;
                        </li>

                        <li>возможность контроля фактически отражаемых операций на основании заложенных в бюджетах
                            предприятия показателей;
                        </li>

                        <li>составление сводной отчетности по результатам мониторинга;</li>

                        <li>финансовый анализ, самостоятельная настройка выполнения финансовых анализов и финансовых
                            расчетов в соответствии с требованиями предприятия;
                        </li>

                        <li>анализ отклонений плановых и фактических данных, сценарный анализ данных бюджетирования;
                        </li>

                        <li>отчетность по управленческому плану счетов.</li>
                    </ul>

                    <p>
                        <b>Подсистема «Управление согласованием и утверждением документов»</b> предоставляет возможность
                        создания маршрутов согласования и утверждения
                        документов для совместной работы и контроля отдельных хозяйственных операций. Доступны следующие
                        возможности:
                    </p>

                    <ul>
                        <li>настройка маршрутов для определенного перечня документов;</li>

                        <li>
                            назначение для одного вида документов нескольких маршрутов, применяемых в зависимости от
                            условий использования и вычисляемых применительно к
                            конкретному экземпляру – документу;
                        </li>

                        <li>произвольное создание точек маршрута – этапов;</li>

                        <li>назначение прав подписи отдельным пользователям, либо группам пользователей, по этапам
                            маршрутов;
                        </li>

                        <li>настройка контроля и автоматического заполнения отдельных реквизитов первичных документов
                            при прохождении этапов согласования и утверждения;
                        </li>

                        <li>формирование списка задач исполнителям;</li>

                        <li>отчетность по состоянию документов на маршрутах;</li>

                        <li>формирование карт маршрутов и карт движения документов по маршрутам;</li>

                        <li>мониторинг состояния выбранных документов – постановка на контроль;</li>

                        <li>мониторинг состояния отдельных документов из формы списка документов и из формы документа,
                            вывод сведений о собранных подписях;
                        </li>

                        <li>настройка условного использования отдельных этапов маршрута;</li>

                        <li>
                            возможность выполнения автоматических действий на этапах маршрута в зависимости от
                            выполнения условий по документу – автоматическое утверждение,
                            отклонение или возврат документа на пересмотр для более эффективного использования времени
                            кадровых ресурсов предприятия;
                        </li>

                        <li>защита от изменения согласуемых документов.</li>
                    </ul>

                    <p>
                        В прикладном решении предусмотрен большой набор ролей, достаточно автономных и позволяющих
                        модульно назначать каждому пользователю только те функции, к
                        которым он должен иметь доступ.
                    </p>

                    <p>
                        Программный продукт «1С-Рейтинг: Бюджетирование предприятия» не включает платформу, для его
                        работы необходимо наличие конфигураций системы программ
                        «1С:Предприятие 8», включающих платформу.
                    </p>
                    <span href="http://1c-rating.kz/sol/adviser/">Онлайн-демонстрация с консультантом</span>
                    <p>
                        Интернет-демонстрация с консультантом позволит Вам получить наиболее полную и достоверную
                        информацию о возможностях прикладного решения. Консультант в
                        режиме реального времени продемонстрирует и подробно расскажет обо всех подсистемах и механизмах
                        прикладного решения, ответит на возникшие вопросы.
                    </p>

                    <p>
                        Перейдя на{}
                        <span href="http://1c-rating.kz/sol/adviser/"
                              title="Заявка на интернет-демонстрацию отраслевого решения с консультантом"
                              target="_self">
            страницу оформления заявки на демонстрацию
        </span>
                        , Вы сможете указать интересующие Вас вопросы и/или разделы прикладного решения, которые
                        необходимо рассмотреть во время интернет-демонстрации.
                        Демонстрация проводится при помощи стандартных средств интернет-браузера, с видео и аудио
                        трансляцией.
                    </p>

                    <p>После оформления заявки с Вами свяжется консультант для уточнения времени проведения
                        демонстрации.</p>
                </div>
            </div>
        </div>
    )
}